import React from 'react';
import './CampaignCreationFooter.scss';

export const CampaignCreationFooter: React.FC = ({ children }, Un) => {
  return <div className="CampaignCreationFooter">{children}</div>;
};
